import { render, staticRenderFns } from "./doubleLine.vue?vue&type=template&id=07f1cb78&scoped=true&"
var script = {}
import style0 from "./doubleLine.vue?vue&type=style&index=0&id=07f1cb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1cb78",
  null
  
)

export default component.exports